import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import TableCategory from "./TableCategory";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";

function CategoryRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableCategory />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default CategoryRegisterPage;